/* eslint-disable sort-keys-fix/sort-keys-fix */
import React, { useEffect, useRef, useState } from "react";
import { Grid, Stack } from "@mui/material";
import { Container, SectionHeading } from "../containers";
import { useHasBeenAlmostVisible } from "../hooks";
// import { dynamicallyLoadIcon } from '../icons';
import { ToggleBtnGroup } from "../toggle";
import { PpCarousel } from "./Carousel";
import {
  DifferencesContainer,
  Icon,
  ItemContainer,
  ItemDescription,
  ItemsContainer,
  ItemTitle,
  ToggleBtnGroupContainer,
} from "./styles";

type TpTier = {
  data: PpCarousel["differences"];
  tierName?: string;
};

export type PpDifferences = {
  darkBackground?: boolean;
  darkMode?: boolean;
  description: string;
  differences: Array<TpTier>;
  sectionName?: string;
  title: string;
};

export function Differences({
  darkBackground = false,
  darkMode = false,
  description,
  differences,
  sectionName,
  title,
  ...rest
}: PpDifferences): React.ReactElement {
  const [currentTier, setCurrentTier] = useState<string | undefined>(undefined);
  const [tiers, setTiers] = useState<Array<string | undefined> | null>(null);
  const [differencesList, setDifferencesList] = useState<
    PpCarousel["differences"]
  >(differences[0].data);

  const elementRef = useRef<HTMLDivElement>(null);
  const shouldRenderContent = useHasBeenAlmostVisible(elementRef);

  useEffect(() => {
    if (differences.length > 1) {
      setCurrentTier(differences[0].tierName);
      setTiers(differences.map((d) => d.tierName));
    } else {
      setCurrentTier(undefined);
      setTiers(null);
    }
  }, [differences]);

  function handleTierChange(newValue: string): void {
    const newTier = differences.find((d) => d.tierName === newValue);
    if (newTier) {
      setDifferencesList(newTier.data);
      setCurrentTier(newTier.tierName);
    }
  }

  return (
    <DifferencesContainer
      ref={elementRef}
      $darkBackground={darkBackground}
      {...rest}
    >
      <Container>
        <Stack alignItems="center">
          <SectionHeading
            description={description}
            sectionName={sectionName}
            textAlign="center"
            textColor={darkMode ? "primary.contrastText" : "primary"}
            title={title}
          />
          {tiers && currentTier && (
            <ToggleBtnGroupContainer>
              <ToggleBtnGroup
                value={currentTier}
                values={tiers.map((t) => ({ name: t }))}
                onChange={handleTierChange}
              />
            </ToggleBtnGroupContainer>
          )}
          <ItemsContainer
            container
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            spacing={4}
          >
            {differencesList.map((diff) => (
              <ItemContainer
                key={diff.indexKey || diff.title}
                container
                item
                sm
                alignItems="center"
                direction={{ xs: "row", md: "column" }}
                spacing={{ xs: 3, md: 1 }}
                wrap="nowrap"
              >
                <Icon item>
                  {/* {shouldRenderContent ? <img alt="" src={diff.icon.url} /> : <div />} */}
                  {/* {shouldRenderContent ? dynamicallyLoadIcon('DiffStar') : <div />} */}
                  {shouldRenderContent ? (
                    <span className="icon-diff4" />
                  ) : (
                    <div />
                  )}
                </Icon>
                <Grid
                  container
                  item
                  alignItems={{ xs: "flex-start", md: "center" }}
                  direction="column"
                >
                  <Grid item>
                    <ItemTitle
                      gutterBottom
                      color={darkMode ? "primary.contrastText" : "primary"}
                      component="h3"
                      variant="diff-title"
                    >
                      {diff.title}
                    </ItemTitle>
                  </Grid>
                  <Grid item>
                    <ItemDescription
                      gutterBottom
                      color={darkMode ? "primary.contrastText" : "primary"}
                      variant="body2"
                    >
                      {diff.description}
                    </ItemDescription>
                  </Grid>
                </Grid>
              </ItemContainer>
            ))}
          </ItemsContainer>
        </Stack>
      </Container>
    </DifferencesContainer>
  );
}
